import { getUserInfo } from '@/api/user'
import { getCmbcUrl } from '@/api/bank'
import { USER_STATUS } from './status'
import { assignIn } from 'lodash'
import Store from 'store'
import Vue from 'vue'
const actions = {
    getUserInfo({ commit }) {
        return getUserInfo().then(data => {
            commit('SET_USER_INFO', data)
            commit('SET_APPLY', {
                applyId: data.applyId,
                applyStatus: data.applyStatus
            })
            commit('SET_QUOTA_INFO', {
                amount: data.creditBalance,
                date: data.expiryMsg
            })
            return Promise.resolve()
        })
    },
    getCmbcUrl({ commit }, payload) {
        commit('null')
        return getCmbcUrl(payload)
    }
}

const mutations = {
    'SET_USER_INFO' (state, payload) {
        state.userInfo = payload
        let userStatus = state.userInfo.userStatus
        if (userStatus === USER_STATUS.TMP_QUOTA_CREDIT || userStatus === USER_STATUS.TMP_QUOTA_CREDIT_ING) {
            state.component = 'award'
        } else if (userStatus === USER_STATUS.CREDIT_FAIL || userStatus === USER_STATUS.QUOTA_APPLY_FAIL) {
            //state.component = Channel.isShowMarket() ? 'market' : 'deny'
            state.component = 'deny'
        } else if (userStatus === USER_STATUS.LOAN_APPLY || userStatus === USER_STATUS.DLXJ_LOAN_APPLY) {
            state.component = 'loan'
        } else if (userStatus === USER_STATUS.QUOTA_APPLY || userStatus === USER_STATUS.QUOTA_APPLY_ING || userStatus === USER_STATUS.QUOTA_CREDIT) {
            state.component = 'redirect'
        } else {
            alert('未知状态')
        }
    },
    'UPDATE_USER_INFO' (state, payload) {
        state.userInfo = assignIn(state.userInfo, payload)
    },
    'RESET_USER' (state) {
        state.userInfo = {}
        state.component = ''
    },
    'SET_USERID' (state, userId) {
        state.userId = userId
        Vue.cookie('userId', userId)
    },

}

const state = {
    userInfo: {},
    component: '',
    userId: 0
}
const getters = {
    userName() {
        return Store.get('username')
    },
    userId() {
        return Vue.cookie('userId');
    }
}
export default {
    state,
    mutations,
    actions,
    getters
}